import { safeParseJSON, type VideoContent } from "@jti/fe-common";

export type VideoMetadata = {
  autoPlay: boolean;
};

export const extractVideoMetadata = (itemVideoContent?: VideoContent | null): VideoMetadata => {
  const metadata = {
    autoPlay: false,
  };

  if (!itemVideoContent?.videoMetadata) {
    return metadata;
  }

  const parsedMetadata = safeParseJSON<{ auto_play: number }>(itemVideoContent.videoMetadata);
  metadata.autoPlay = Number(parsedMetadata?.auto_play || 0) === 1;

  return metadata;
};
